export enum ChatType {
    DIRECTMESSAGE = "directMessage"
}

export enum BodyType {
    PLAINTEXT = "plainText"
}

export enum HTTTPMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE"
}

export enum ChatState {
    INITIAL = 'initial',
    PEOPLESEARCH = 'peopleSearch',
    CHAT = 'chat',
    MENUFULLSCREEN = 'menuFullScreen',
    CHATFULLSCREEN = 'chatFullScreen',
}

export enum ScreenState {
    ACTIVE = "active",
    INACTIVE = "inactive"
}

export interface IChatLocalisationStrings {
    [string: string]: any
}

export interface IParentHttpClient {
    get?: (...args:any) => Promise<any>
    post?: (...args:any) => Promise<any>
    delete?: (...args:any) => Promise<any>
    put?: (...args: any) => Promise<any>
}

export interface IPaginatedResponse<T> {
  items: T,
  nextSkip: number,
  previousSkip: number,
  totalItemCount: number
}

export interface IUser {
    id: number,
    displayName: string,
    profileEmail: string,
    profilePhoneNumber: string,
    department: string,
    isActive: boolean,
    jobRole: string,
    profilePicture: {
        id: number,
        fileName: string,
        uri: string,
        width: number,
        height: number
    }
}

export interface IMessageBody {
    bodyType: BodyType,
    plainText: string
}

export interface IChatMessage {
    id: string,
    senderId: number,
    sentAt: string,
    body: IMessageBody,
    timestamp: string,
    isSent: boolean,
    sendingError?: boolean
}

export interface IPeopleSearch {
    nameFilter?: string
    skip?: number,
    top: number,
}

export interface IPeopleSearchUser {
    email: string;
    firstName: string;
    lastName: string;
    userName: string;
    displayName: string;
    jobRole: string;
    profilePictureUrl: string;
    id: number;
    profileEnabled: boolean;
    displayNameSet: boolean;
    profileEmail: string;
    profilePhoneNumber: string;
    department: string;
    profilePicture: {
        id: number;
        filename: string;
        uri: string;
        width: number;
        height: number;
    };
    isActive: boolean;
}

export interface IPeopleSearchResults {
    nextUrl: string,
    previousUrl: string,
    profiles: IPeopleSearchUser[];
    totalProfileResults: number;
}

export interface IChatMessagePayload {
    id: string,
    senderId: number,
    sentAt: string,
    body: IMessageBody,
    timestamp: string,
    isSent: boolean,
    sendingError?: boolean
}

export interface IChatMeta {
    id: number,
    chatType: ChatType,
    timestamp:  string,
    lastMessage: IChatMessage,
    users: IUser[],
    isNewChatPlaceholder?: boolean
}

export interface IChatMessageResponse{ 
    items: IChatMessage[],
    nextSkip: null,
    previousSkip: null,
    totalItemCount: 5
}

export interface ICreateNewChatPayload {
    chatType: ChatType,
    message: IChatMessage
    targetUserId: number
}

export interface IChatMessagePayload {
    message: IChatMessage
}


export interface IMessageParts {
    type: 'plaintext' | 'linebreak';
    text?: string
}

//components
export interface IContactInformationProps {
    profileImageUrl: string,
    displayName: string,
    jobRole?: string,
    department?: string
}

export interface IContactButtonProps extends IContactInformationProps {
    onClickContact: () => void,
}